import React, {useEffect} from 'react';
import {useUrlSearchParams} from 'use-url-search-params';
import styles from './layout.module.scss';
import AppContentView from '@crema/core/AppContentView';
import Layouts from './Layouts';
import AppScrollbar from '../AppScrollbar';
import {
  useLayoutActionsContext,
  useLayoutContext,
} from '../../utility/AppContextProvider/LayoutContextProvider';
import {useAuthUser} from '../../utility/AuthHooks';
import {useSidebarActionsContext} from '../../utility/AppContextProvider/SidebarContextProvider';
import clsx from 'clsx';

const AppLayout = () => {
  const {isAuthenticated} = useAuthUser();
  const {navStyle} = useLayoutContext();
  const {updateNavStyle} = useLayoutActionsContext();
  const {updateMenuStyle, setSidebarBgImage} = useSidebarActionsContext();
  const [params] = useUrlSearchParams();

  const AppLayout = Layouts[navStyle];

  useEffect(() => {
    if (params.layout) updateNavStyle(params.layout);
    if (params.menuStyle) updateMenuStyle(params.menuStyle);
    if (params.sidebarImage) setSidebarBgImage(true);
  }, []);
  (function (c, l, a, r, i, t, y) {
    c[a] =
      c[a] ||
      function () {
        (c[a].q = c[a].q || []).push(arguments);
      };
    t = l.createElement(r);
    t.async = 1;
    t.src = 'https://www.clarity.ms/tag/' + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, 'clarity', 'script', 'ez6liwy4kp');

  return (
    <React.Fragment>
      {isAuthenticated ? (
        <AppLayout />
      ) : (
        <div className={clsx(styles.auth, 'd-flex flex-column min-vh-100')}>
          <AppScrollbar className={clsx(styles.authScroll, 'd-flex flex-column min-vh-100')}>
            <AppContentView />
          </AppScrollbar>
        </div>
      )}
    </React.Fragment>
  );
};

export default React.memo(AppLayout);
